import React from "react";
import useTranslate from "../../../core/languages/hooks/useTranslate";

const TermsAndConditions = () => {
    const t = useTranslate();

    return (
        <>
            <div className="border-t border-neutral-200 dark:border-neutral-700 pt-6">
                <h4 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-4">
                    {t("transfers.fields.termsAndConditions")}
                </h4>
            </div>
            <div>
                <p>{t("transfers.fields.termsAndConditionsInfo.cancellation")}</p><br/>
                <p>{t("transfers.fields.termsAndConditionsInfo.missedFlights")}</p><br/>
                <p>{t("transfers.fields.termsAndConditionsInfo.flightDelays")}</p>
            </div>
        </>
    );
}

export default TermsAndConditions;
